<template>
    <v-col>
        <v-card class="mx-auto pa-5" max-width="350" :color="plan.planName == 'Free' ? '#DDDDDD' : '#FFFFFF'" outlined>
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-subtitle :class=" plan.planName == 'Free' ? 'd-flex justify-center' : 'd-flex justify-left'">
                        <span class="subheading black--text">{{ $t('community') }}</span>
                    </v-list-item-subtitle>
                    <v-list-item-title :class=" plan.planName == 'Free' ? 'd-flex justify-center' : 'd-flex justify-left'">
                        <span class="display-1 font-weight-bold">{{plan.planName}}</span>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <span class="d-flex justify-center subheading my-3" style="color: #777777">{{ $t('youWillGet') }}</span>
            <span class="d-flex justify-center" v-if="plan.planName !== 'Free'" v-html="$t('allOfThePreviousPlus')"></span>
            <div v-bind:key="propertie" v-for="propertie in planProperties">
                <v-list-item>
                    <v-list-item-icon class="mr-0">
                        <v-icon small color="#25AE88">fa-check-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>
                        <span class="subheading black--text" v-html="propertie"></span>
                    </v-list-item-subtitle>
                </v-list-item>
            </div>
            <v-divider v-if="plan.planName !== 'Free'" class="mx-3"></v-divider>
            <v-list-item v-if="plan.planName !== 'Free'" class="my-2">
                <v-list-item-subtitle class="d-flex justify-center">
                    <span class="title font-weight-bold black--text">{{plan.price}} {{plan.currency}}</span>
                    <!-- Add condition when switch changes, maybe prop -->
                    <span class="title" v-html="periodIndex == 0 ? $t('month') : periodIndex == 1 ? $t('semester') : $t('year')"></span>
                </v-list-item-subtitle>
            </v-list-item>
            <v-container fluid>
                <v-row align="center" justify="center">
                    <!--ePayco Button!-->
                    <v-btn v-if="plan.planName == 'Free' || this.$store.state.user.details.country === 'Colombia'" class="my-2" style="background-color: #25AE88; color:#FFFFFF" color="white" plain @click="payNow">
                        {{plan.planName !== 'Free' ? $t('buyNow') : $t('choose')}} »
                    </v-btn>
                    <!-- Paypal Button!-->
                    <div v-else class="paypal-button-container"></div>
                </v-row>
            </v-container>
        </v-card>
    </v-col>
</template>

<script>
export default {
    name: "PlanCardClub",
    props: {
        plan: Object,
        periodIndex: Number
    },
    data() {
        return {
           planProperties: this.plan.properties.en, 
        }
    },
    watch: {
        '$i18n.locale': function(){
            this.refreshPricingPlansLanguage();
        }
    },
    mounted() {
        this.refreshPricingPlansLanguage();
    },
    methods: {
        refreshPricingPlansLanguage() {
            this.planProperties = (this.$i18n.locale === "en") ? this.plan.properties.en : this.plan.properties.es;
        },
        payNow() {
            this.$emit('payNow', this.plan);
        }
    }
}
</script>

<style scoped>

</style>

<i18n>
{
    "en": {
        "community": "Community",
        "youWillGet": "You'll get",
        "allOfThePreviousPlus": "All of the previous plan plus...",
        "month": "&nbsp;/month",
        "semester": "&nbsp;/semester",
        "year": "&nbsp;/year",
        "buyNow": "Buy now",
        "choose": "Choose"
    },
    "es": {
        "community": "Comunidad",
        "youWillGet": "Obtendrás",
        "allOfThePlan": "Todo lo del anterior plan más...",
        "month": "&nbsp;/mes",
        "semester": "&nbsp;/semestre",
        "year": "&nbsp;/año",
        "buyNow": "Comprar ahora",
        "choose": "Escoger"
    }
}
</i18n>